<template>
  <div v-if="groupings.length > 0">
    <div class="ml-2 text-h6">{{ $t('conflict.previousGroupings') }}</div>
    <v-list>
      <div
        v-for="(grouping, index) in groupings"
        :key="index"
      >
        <span v-if="showDetails" class="text-caption">
          {{ $t('conflict.grouping', { groupId: grouping.id }) }}
        </span>
        <v-list-item>
          <v-list-item-icon>
            <span class="rai-wigo box">
              <wigo-chip
                v-for="(group, index) in grouping.members"
                :key="index"
                :wigo="group"
                class="mr-2 my-1"
              />
            </span>
          </v-list-item-icon>
        </v-list-item>
        <v-divider/>
      </div>
    </v-list>
  </div>
</template>
<script>
import WigoChip from '@/components/global/WigoChip';

export default {
  name: 'ContextualGroups',

  components: { WigoChip },

  data() {
    return {
    };
  },

  props: {
    groupings: {
      type: Array,
      required: true,
    },
    showDetails: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
  },

  methods: {
  },

  created() {
  },

};
</script>
<style>
</style>